import { cn } from '@/lib/utils/cn';

const STEPS: ReadonlyArray<{ title: string; body: string }> = [
  {
    title: 'Connect Source',
    body: 'Link your Notion workspace, GitHub repo, or construct directly within our blazing-fast native editor.',
  },
  {
    title: 'Select Anatomy',
    body: 'Choose from dozens of highly-crafted architectural layouts. Tweak type, spacing, and color palettes.',
  },
  {
    title: 'Map & Deploy',
    body: 'Attach your custom domain. Hit publish. Your content is distributed to global edge networks instantly.',
  },
];

export function HowItWorks() {
  return (
    <section id="how" className="border-y border-line bg-board py-24">
      <div className="mx-auto max-w-container px-6">
        <div className="relative grid grid-cols-1 gap-12 text-center md:grid-cols-3 md:text-left">
          <div
            aria-hidden
            className="absolute left-[15%] right-[15%] top-[4.5rem] hidden h-px border-t border-dashed border-line md:block"
          />
          {STEPS.map((step, index) => {
            const isFinal = index === STEPS.length - 1;
            return (
              <article
                key={step.title}
                className="group relative z-10 flex flex-col items-center md:items-start"
              >
                <span
                  className={cn(
                    'mb-6 flex h-12 w-12 items-center justify-center rounded-full font-mono text-lg font-semibold shadow-sm transition-transform group-hover:scale-110',
                    isFinal ? 'bg-ink text-board' : 'border border-line bg-board',
                  )}
                >
                  {index + 1}
                </span>
                <h4 className="mb-2 font-display text-lg font-semibold">{step.title}</h4>
                <p className="max-w-xs text-sm text-ink-muted">{step.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
